import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import _asyncToGenerator from "F:\\\u80F6\u5DF1\u4EBA\\jjr_store_reservation\\node_modules\\@babel\\runtime\\helpers\\esm\\asyncToGenerator.js";
import _defineProperty from "F:\\\u80F6\u5DF1\u4EBA\\jjr_store_reservation\\node_modules\\@babel\\runtime\\helpers\\esm\\defineProperty.js";
import "vant/es/image-preview/style";
import _ImagePreview from "vant/es/image-preview";
import "vant/es/popup/style";
import _Popup from "vant/es/popup";
import "vant/es/field/style";
import _Field from "vant/es/field";
import "vant/es/submit-bar/style";
import _SubmitBar from "vant/es/submit-bar";
import "vant/es/radio/style";
import _Radio from "vant/es/radio";
import "vant/es/radio-group/style";
import _RadioGroup from "vant/es/radio-group";
import "vant/es/icon/style";
import _Icon from "vant/es/icon";
import "vant/es/goods-action/style";
import _GoodsAction from "vant/es/goods-action";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/tag/style";
import _Tag from "vant/es/tag";
import "vant/es/card/style";
import _Card from "vant/es/card";
import "vant/es/button/style";
import _Button from "vant/es/button";

var _components;

import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { urlScheme } from '@/api/user';
import { create, orderRecords, pay, detail } from '@/api/order';
import { userInfo } from '@/api/user';
var isPayTimer = null;
export default {
  name: 'Home',
  components: (_components = {}, _defineProperty(_components, _Button.name, _Button), _defineProperty(_components, _Card.name, _Card), _defineProperty(_components, _Tag.name, _Tag), _defineProperty(_components, _Toast.name, _Toast), _defineProperty(_components, _GoodsAction.name, _GoodsAction), _defineProperty(_components, _Icon.name, _Icon), _defineProperty(_components, _RadioGroup.name, _RadioGroup), _defineProperty(_components, _Radio.name, _Radio), _defineProperty(_components, _SubmitBar.name, _SubmitBar), _defineProperty(_components, _Field.name, _Field), _defineProperty(_components, _Popup.name, _Popup), _defineProperty(_components, _ImagePreview.Component.name, _ImagePreview.Component), _components),
  data: function data() {
    return {
      goodsDetails: JSON.parse(this.$route.query.detailsData),
      // 商品信息
      userInfo: {},
      // 用户信息
      userRadio: null,
      isShowPopup: false,
      userInfoArr: [],
      // 用户以往记录下拉数据
      reportImgArr: [],
      // 验光报告
      mark: '',
      // 订单备注
      payDialogVisible: false,
      // 支付方式弹窗
      payRadio: 1,
      orderId: null,
      // 订单id
      showLoading: false,
      // 支付loading
      submitLoading: false // 提交loading

    };
  },
  created: function created() {
    var status = window.localStorage.getItem('isPaying');

    if (+status === 1) {
      this.showLoading = true;
      clearTimeout(isPayTimer);
      this.loopPayStatus(4);
    }

    this.getReportImgArr();
    this.getOrderRecords();
  },
  methods: {
    // 获取用户上传的验光报告
    getReportImgArr: function getReportImgArr() {
      var _this = this;

      userInfo().then(function (res) {
        if (res.error.code === 0) {
          var imgTemp = res.data.report_image;
          var reportImgArr = [];
          imgTemp.forEach(function (element) {
            reportImgArr.push({
              src: element,
              selected: false
            });
          });
          _this.reportImgArr = reportImgArr;
        }
      });
    },
    // 用户以往记录
    getOrderRecords: function getOrderRecords() {
      var _this2 = this;

      orderRecords().then(function (res) {
        if (res.error.code === 0) {
          _this2.userInfoArr = res.data;
        }
      });
    },
    // 展现用户信息
    showPopup: function showPopup() {
      this.isShowPopup = true;
    },
    // 确定选择
    selectdUserInfo: function selectdUserInfo() {
      var _this3 = this;

      if (!this.userRadio) {
        _Toast('请选择一条数据');

        return;
      }

      var temp = this.userInfoArr.find(function (item) {
        return item.name === _this3.userRadio;
      });
      this.userInfo = JSON.parse(JSON.stringify(temp));
      this.isShowPopup = false;
    },
    // 去付款
    onSubmit: function onSubmit() {
      var _this4 = this;

      if (!this.userInfo.name) {
        _Toast('请输入姓名');

        return;
      }

      if (!this.userInfo.gender) {
        _Toast('请输入性别');

        return;
      }

      if (!this.userInfo.age) {
        _Toast('请输入年龄');

        return;
      }

      this.submitLoading = true;
      var data = {
        product_id: this.goodsDetails.id,
        mark: this.mark
      };
      var selectedArr = [];
      this.reportImgArr.forEach(function (item) {
        if (item.selected) {
          selectedArr.push(item.src);
        }
      });
      this.userInfo.reportImg = selectedArr;
      data.user_message = JSON.stringify(this.userInfo);
      create(data).then(function (res) {
        if (res.error.code === 0) {
          _this4.submitLoading = false;
          _this4.orderId = res.data;
          window.localStorage.setItem('orderId', res.data);
          _this4.payDialogVisible = true; // Toast('下单成功')
          // this.$router.push({ name: 'home' })
        }
      });
    },
    // 跳转逻辑
    jumpPayment: function jumpPayment() {
      var _this5 = this;

      // if (this.payRadio === 1) {
      //   urlScheme({
      //     order_id: this.orderId
      //   }).then((res) => {
      //     //
      //   })
      //   Toast('功能开发中')
      //   return
      // }
      this.payDialogVisible = false;
      this.showLoading = true;

      if (this.payRadio === 1) {
        urlScheme({
          order_id: this.orderId
        }).then(function (res) {
          window.localStorage.setItem('orderId', _this5.orderId);
          window.localStorage.setItem('isPaying', '1');
          clearTimeout(isPayTimer);

          _this5.loopPayStatus(5);

          location.href = res.data;
        });
      } else if (this.payRadio === 2) {
        var params = {
          order_id: this.orderId,
          pay_channel: this.payRadio
        };
        pay(params).then(function (res) {
          if (res.error.code === 0) {
            window.localStorage.setItem('isPaying', '1');
            clearTimeout(isPayTimer);

            _this5.loopPayStatus(2); // ios里好像不支持window.open打开，所以就改成了a标签模拟点击跳转


            var link = document.createElement('a');
            link.setAttribute('href', window.location.origin + '/middle.html?jump=' + encodeURIComponent(res.data.expend.pay_info));
            document.body.appendChild(link);
            link.click();
          }
        });
      }
    },
    loopPayStatus: function loopPayStatus(times) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var order_id, res, paid, code, self, _self;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(times === 0)) {
                  _context.next = 6;
                  break;
                }

                _this6.showLoading = false;
                window.localStorage.removeItem('isPaying');
                window.localStorage.removeItem('orderId');

                _Dialog.confirm({
                  title: '',
                  message: '支付异常！订单已生成，请到订单页检查支付是否成功，成功可以预约，失败则需重新支付！',
                  showCancelButton: false
                }).then(function () {
                  window.history.go(-1);
                });

                return _context.abrupt("return", Promise.reject());

              case 6:
                _context.prev = 6;
                order_id = window.localStorage.getItem('orderId');
                _context.next = 10;
                return detail({
                  order_id: order_id
                });

              case 10:
                res = _context.sent;
                paid = res.data.order.paid;
                code = res.error.code;

                if (code !== 0) {
                  window.history.go(-1);
                  window.localStorage.removeItem('isPaying');
                  window.localStorage.removeItem('orderId');
                }

                if (paid === 0) {
                  self = _this6;
                  isPayTimer = setTimeout(function () {
                    self.loopPayStatus(times - 1);
                  }, 5000);
                } else if (paid === 1) {
                  _this6.showLoading = false;

                  _Dialog.confirm({
                    title: '',
                    message: '支付成功，请到订单页预约！',
                    showCancelButton: false
                  }).then(function () {
                    window.history.go(-1);
                    window.localStorage.removeItem('isPaying');
                    window.localStorage.removeItem('orderId');
                  });
                } else {
                  _Dialog.confirm({
                    title: '',
                    message: '未能获取支付状态，请刷新页面',
                    showCancelButton: false
                  }).then(function () {
                    window.history.go(-1);
                    window.localStorage.removeItem('isPaying');
                    window.localStorage.removeItem('orderId');
                  });
                }

                _context.next = 22;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](6);
                console.log(_context.t0); // window.location.reload()
                // window.localStorage.removeItem('isPaying')
                // window.localStorage.removeItem('orderId')

                _self = _this6;
                isPayTimer = setTimeout(function () {
                  _self.loopPayStatus(times - 1);
                }, 5000);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 17]]);
      }))();
    },
    // 选择图片
    selectImg: function selectImg(imgItem, imgIndex) {
      this.reportImgArr[imgIndex].selected = !imgItem.selected;
    },
    // 展示图片
    showImg: function showImg(arr, index) {
      _ImagePreview({
        images: arr.map(function (item) {
          return item.src;
        }),
        closeable: true,
        startPosition: index
      });
    },
    // 返回
    onClickLeft: function onClickLeft() {
      this.$router.go(-1);
    }
  }
};